import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
export class DocumentationLegacyPageBlockContextMcp extends DocumentationLegacyPageBlock {
    constructor(model, children) {
        var _a;
        super(model, children);
        this.properties = {
            context: (_a = model.contextMcpBlockConfig) !== null && _a !== void 0 ? _a : { value: [], connections: [] },
        };
    }
}
